import moment from 'moment';
export default {
	totalSize_: state => {
		const { totalSize } = state.pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pageUnit } = state.pagingInfo;
		return pageUnit;
	},
	getStartInitDd_: ({ searchParams }) => searchParams.initStartDt,
	getEndInitDd_: ({ searchParams }) => searchParams.initEndDt,
	getStartDcsnDd_: ({ searchParams }) => searchParams.startDcsnDd,
	getEndDcsnDd_: ({ searchParams }) => searchParams.endDcsnDd,
	getStartMonth_: ({ searchParams }) => searchParams.initStartMonth,
	resultFileList_({ fileList }) {
		return fileList;
	},
	//상태값
	getIsSaveFlag_({ isSaveFlag }) {
		return isSaveFlag;
	}
};
